import script from "./TimezoneSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./TimezoneSelector.vue?vue&type=script&lang=ts&setup=true"

import "./TimezoneSelector.vue?vue&type=style&index=0&id=99afc674&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99afc674"]])

export default __exports__